import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { contactChannels, mainNav, siteConfig } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-file-shield-2-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteConfig.fullName}</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200/90">
              {siteConfig.tagline}。我们持续整理公开可查的跨境诈骗线索，把它写成看得懂、用得上的档案，帮助更多人避开高薪招聘、虚假投资与跨境偷渡的陷阱。
            </p>
            <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-background-300/80">
              <i className="ri-information-line mt-0.5" aria-hidden="true"></i>
              <span>本站内容已做匿名化处理，仅用于反诈科普与风险提示，不针对任何具体个人或机构。</span>
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">站内导航</h3>
            <ul className="mt-5 space-y-3 text-sm">
              {mainNav.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-200/90 transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">专题分类</h3>
            <ul className="mt-5 space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/archives?category=${cat.slug}`}
                    className="text-background-200/90 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-800/70 pt-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-background-300/80">
              © {year} {siteConfig.fullName} · 内容仅供反诈科普参考
            </p>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-300/80">
              {contactChannels.slice(0, 2).map((ch) => (
                <span key={ch.label} className="flex items-center gap-1.5">
                  <i className={ch.icon} aria-hidden="true"></i>
                  {ch.value}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}